const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/supervisor/assets.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/supervisor/assets.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { AdminDashboardAssetsSkeleton } from '@/features/admin-dashboard/components/AdminDashboardAssetsSkeleton';
import { assetCatalogSearchSchema, searchToRequestFilters } from '@/features/admin-dashboard/lib/assetCatalogSearch';
import { assetCatalogQuery } from '@/features/assets/services/assetCatalogQueries';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { createFileRoute } from '@tanstack/react-router';

/**
 * Supervisor → Assets. The blank-filter catalog is a valid request, so the
 * loader warms its first page and the route owns the matching pending skeleton.
 */
export const Route = createFileRoute('/_authenticated/_app/supervisor/assets')({
  beforeLoad: requireCapabilities(has => has('assets.list')),
  validateSearch: assetCatalogSearchSchema,
  loaderDeps: ({
    search
  }) => searchToRequestFilters(search),
  loader: async ({
    cause,
    context,
    deps
  }) => {
    const query = assetCatalogQuery(deps);
    const hasCachedData = context.queryClient.getQueryState(query.queryKey)?.data !== undefined;
    if (cause === 'enter' && !hasCachedData) {
      await context.queryClient.ensureInfiniteQueryData(query);
    }
  },
  shouldReload: false,
  pendingComponent: AdminDashboardAssetsSkeleton,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});